var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossroad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 9 6 9 3 12 6 15 16 15",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 4 26 4 29 7 26 10 20 10",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 14 26 14 29 17 26 20 20 20",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 31,
    x2: 12,
    y2: 31,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 31,
    x2: 16,
    y2: 1,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossroad);
export default __webpack_public_path__ + "static/media/crossroad.c43bd8ea6f7c03e4746f2a1fa8aa05c8.svg";
export { ForwardRef as ReactComponent };